import { useState, useEffect } from "react";
import { Form, Input } from "antd";
import { useOrganizationBilling } from "../../../api/Organizations";
import Loading from "../../../components/Loading";
import SubmitButton from "../../../components/SubmitButton";

const OrganizationBilling = ({ organizationId }) => {
  const [dirty, setDirty] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [contact, setContact] = useState();
  const { data, isLoading } = useOrganizationBilling(organizationId);

  useEffect(() => {
    if (data?.organizationContact) {
      setContact(data.organizationContact);
    }
  }, [data]);

  return !contact ? (
    <Loading />
  ) : (
    <Form
      initialValues={contact}
      layout="vertical"
      onFieldsChange={() => setDirty(true)}
    >
      <Form.Item name="Email" label="Email">
        <Input />
      </Form.Item>
      <Form.Item name="Phone" label="Phone">
        <Input placeholder="(XXX) XXX - XXXX" />
      </Form.Item>
      <Form.Item name="address1" label="Address Line 1">
        <Input placeholder="Street Address" />
      </Form.Item>
      <Form.Item name="address2" label="Address Line 2">
        <Input placeholder="Unit / Apt Number" />
      </Form.Item>
      <Form.Item name="city" label="City">
        <Input placeholder="City" />
      </Form.Item>
      <Form.Item name="state" label="State / Providence">
        <Input placeholder="State" />
      </Form.Item>
      <Form.Item name="zip" label="Zip / Postal Code">
        <Input placeholder="Zip / Postal Code" />
      </Form.Item>
      <Form.Item>
        <SubmitButton disabled={!dirty} submitting={submitting} type="primary">
          Save
        </SubmitButton>
      </Form.Item>
    </Form>
  );
};

export default OrganizationBilling;
